module.exports = __webpack_public_path__ + "img/car-parking.7d0fa887.png";